export const SPOTLIGHTS_SECTION_ID = 'spotlights';

export const getSectionElement = (sectionId) => {
  if (!sectionId) return null;

  const id = String(sectionId);
  const escaped = CSS.escape(id);

  return (
    document.getElementById(id) ||
    document.querySelector(`[data-cy="builder-${escaped}-section"]`) ||
    document.querySelector(`[data-cy="builder-classic-${escaped}-section"]`) ||
    document.querySelector(`[data-cy="${escaped}-section"]`) ||
    document.getElementById(`anchor-${id}`)
  );
};
